module.exports = __webpack_public_path__ + "img/ltkparties-2x.b3a5a88.jpg";